import { simplifyUrl } from '@/lib/url'
import { loadRelayInfo, type RelayInfoDocument } from '@nostr/gadgets/relays'
import { useEffect, useState } from 'react'

export function useFetchRelayInfo(url: string) {
  const [isFetching, setIsFetching] = useState(true)
  const [relayInfo, setRelayInfo] = useState<RelayInfoDocument>({
    url,
    urlSimple: simplifyUrl(url)
  })

  useEffect(() => {
    if (!url) return
    const fetchRelayInfos = async () => {
      setIsFetching(true)
      const timer = setTimeout(() => {
        setIsFetching(false)
      }, 5000)
      try {
        const relayInfo = await loadRelayInfo(url)
        if (relayInfo) setRelayInfo(relayInfo)
      } catch (err) {
        console.error(err)
      } finally {
        clearTimeout(timer)
        setIsFetching(false)
      }
    }

    fetchRelayInfos()
  }, [url])

  return { relayInfo, isFetching }
}
